import React from "react";
import { ToastProvider } from "react-toast-notifications";
import {
  ApolloProvider,
  InMemoryCache,
  ApolloClient,
  ApolloLink,
  HttpLink,
  concat,
  split,
} from "@apollo/client";
import Cookies from 'js-cookie';
import * as _ from "lodash";
import { getMainDefinition } from "@apollo/client/utilities";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

import { ACCESS_TOKEN, SERVER_URI, SHOW_NOTICE_EXPIRED, SOCKET_SERVER_URI, USER_KEY2 } from "./constants";
import { useInitFbSDK } from "./helpers/fb-hooks";
import { StateProvider } from "./store";
import 'slider-moon/dist/style.css'


import { store, persistor } from "./redux/store";
import AppRoute from "./routes";


function App() {
  const isFbSDKInitialized = useInitFbSDK();
 

  const httpLink = new HttpLink({
    uri: SERVER_URI, // use https for secure endpoint
  });

  // Create a WebSocket link:
  const wsLink = new GraphQLWsLink(
    createClient({
      url: SOCKET_SERVER_URI,
      options: {
        reconnect: true,
      },
      // connectionParams: {
      //   authentication: user.authToken,
      // },
    })
  );
  // const wsLink = new WebSocketLink({
  //   uri: SOCKET_SERVER_URI, // use wss for a secure endpoint
  //   options: {
  //     reconnect: true,
  //   },
  // });

  // remove show notice expired from cookie
  // Cookies.remove(SHOW_NOTICE_EXPIRED);

  const link = split(
    // split based on operation type
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query);
      return kind === "OperationDefinition" && operation === "subscription";
    },
    wsLink,
    httpLink
  );

  const authMiddleware = new ApolloLink((operation, forward) => {
    // const user = localStorage.getItem(USER_KEY2);
    const accessToken = Cookies.get(ACCESS_TOKEN);
    let token;
    if (accessToken) {
      token = accessToken;
    }
    // add the authorization to the headers
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization: token ?? "",
      },
    }));

    return forward(operation);
  });

  const client = new ApolloClient({
    link: concat(authMiddleware, link),
    cache: new InMemoryCache(),
    request: (operation) => {
      // const user = localStorage.getItem(USER_KEY2);
      const accessToken = Cookies.get(ACCESS_TOKEN);
      if (accessToken) {
        const token = accessToken;
        operation.setContext({
          headers: {
            authorization: token ?? "",
          },
        });
        return;
      }
    },
    onError: (err) => {
      let isTokenError1 = _.some(err.graphQLErrors, {
        message: "Error: TokenExpiredError: jwt expired",
      });
      let isTokenError2 = _.some(err.graphQLErrors, {
        message: "Error: JsonWebTokenError: jwt must be provided",
      });
      if (isTokenError1 || isTokenError2) {
        window.location.replace("/");
      }
    },
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={client}>
          <ToastProvider>
            <StateProvider>
              <AppRoute />
            </StateProvider>
          </ToastProvider>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  );
}
export default App;
